import { useNavigate } from 'react-router';

import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';

import { EditRemoveBtn } from 'components/buttons';
import { PanelGrid } from 'components/grid';
import { Block, OneColumn } from 'components/page';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useQueryGrupoExibicao } from 'pages/cadastro/secoes/hooks/usQueryGrupoExibicao';
import { GrupoExibicaoProps } from 'pages/cadastro/loja/types';
import { LojaListGrupoExibicaoFilter } from 'pages/cadastro/secoes/components';

const gridRows = (rows: GrupoExibicaoProps[] | undefined): GridRowsProp => {
    if (!rows) return [];
    return rows.map((row, index) => {
        return { ...row, id: index + 1 };
    });
};

export function LojaListSecoesComp() {
    const { data, refetch, isFetching } = useQueryGrupoExibicao();
    const { hasPermission } = usePermissionsContext();
    const navigate = useNavigate();

    const columns: GridColDef[] = [
        { field: 'idConfiguracaoPropriedadeGrupoExibicao', headerName: 'Código', minWidth: 80 },
        { field: 'dsConfiguracaoPropriedadeGrupoExibicao', headerName: 'Seção', flex: 1, minWidth: 100 },
        { field: 'nrSequencia', headerName: 'Ordem de apresentação', minWidth: 80 },
    ];

    if (hasPermission(['SECAO_GERENCIAR'])) {
        columns.push({
            field: 'acoes',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Ações',
            filterable: false,
            sortable: false,
            hideable: false,
            disableColumnMenu: true,
            width: 80,
            minWidth: 60,
            renderCell: (params) => (
                <EditRemoveBtn
                    id={params.row.idConfiguracaoPropriedadeGrupoExibicao}
                    sx={{ ml: 'auto', p: 1.5 }}
                    showEditBtn={hasPermission(['SECAO_GERENCIAR'])}
                    showRemoveBtn={hasPermission(['SECAO_GERENCIAR'])}
                    removeUrl={`/gestao/configuracaopropriedadegrupoexibicao/${params.row.idConfiguracaoPropriedadeGrupoExibicao}`}
                    refresh={refetch}
                    extraContent={
                        <ViewColumnIcon
                            onClick={() => {
                                navigate(`/cadastro/colunas/${params.row.idConfiguracaoPropriedadeGrupoExibicao}`);
                            }}
                            sx={{ alignSelf: 'center' }}
                        />
                    }
                />
            ),
        });
    }

    return (
        <OneColumn title="Seções" createButton={hasPermission(['SECAO_DADOS_ALTERAR'])} goBackButton>
            <LojaListGrupoExibicaoFilter />

            <Block>
                <PanelGrid
                    rows={gridRows(data?.data)}
                    rowsCount={data?.total ?? 0}
                    reload={refetch}
                    loading={isFetching}
                    columns={columns}
                    visibleRows={10}
                />
            </Block>
        </OneColumn>
    );
}
